import React from "react";
import { Navigate } from "react-router";
import { usePermissions } from "../hooks/usePermissions";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireFullAccess?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireFullAccess = true,
}) => {
  // Use a try-catch to handle the case where QueryClient is not available yet
  let hasFullAccess = true; // Default to full access to avoid blocking initial render
  let isLoading = true;

  try {
    const {
      hasFullAccess: userHasFullAccess,
      isLoading: permsLoading,
    } = usePermissions();
    hasFullAccess = userHasFullAccess;
    isLoading = permsLoading;
  } catch (error) {
    // If QueryClient is not available, default to full access
    // This ensures the app can render and authentication can work
    console.log("QueryClient not available yet, defaulting to full access");
  }

  // Don't redirect while the user identity is still loading — otherwise
  // ProtectedRoute bounces to / before useGetIdentity has a chance to
  // populate the user, even when the eventual user IS allowed.
  // If they aren't allowed, the redirect will fire after the load.
  if (requireFullAccess && !hasFullAccess && !isLoading) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}; 